import React from 'react'
import { Flex, SearchSelect, styled } from '@fareye/ui'
import { terminalView } from '@fareye/configs'

const SearchSelectWrapper: any = styled.div`
  display: inline-block;
  width: 170px;
  height: fit-content;
  margin-right: 16px;
  @media (min-width: 3840px) {
    width: 560px;
    margin-right: 40px;
  }
`

const customStyles: any = {
  option: (state: any) => {
    return {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '22px',
      '@media (min-width: 3840px)': {
        fontWeight: 500,
        fontSize: '44px',
        lineHeight: '52px',
        paddingTop: '16px',
        paddingBottom: '16px'
      },
      background:
        state.isFocused || state.isSelected
          ? terminalView.darkTheme.dropDown.isFocused.background
          : terminalView.darkTheme.dropDown.background,
      color:
        state.isFocused || state.isSelected
          ? terminalView.darkTheme.dropDown.isFocused.color
          : terminalView.darkTheme.dropDown.color
    }
  },
  dropdownIndicator: {
    display: 'flex',
    transform: 'rotate(0deg) !important',
    margin: 0,
    justifyContent: 'center',
    alignItems: 'center',
    '@media (min-width: 3840px)': {
      width: '100px',
      svg: {
        height: 50,
        width: 50
      }
    }
  },
  indicatorSeparator: { display: 'none' },
  control: {
    borderTopWidth: '1.02px',
    borderRadius: '2px',
    color: terminalView.darkTheme.dropDown.color,
    background: terminalView.darkTheme.dropDown.background,
    alignItems: 'center',
    border: `2px solid ${terminalView.darkTheme.dropDown.border}`,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    marginRight: '16px',
    padding: '0px 4px',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    '@media (min-width: 3840px)': {
      fontWeight: 500,
      fontSize: '44px',
      lineHeight: '52px'
    }
  },
  singleValue: {
    background: '23252F',
    color: terminalView.darkTheme.textColor
  },
  valueContainer: {
    overflow: 'hidden !important',
    height: '32px !important',
    '@media (min-width: 3840px)': {
      height: '118px !important'
    }
  },
  container: {
    borderRadius: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  wrapper: {}
}
export const Dropdown = (props: any) => {
  function setValue(a: any) {
    props.setValue(a)
    if (a.pageSize) {
      props.setPageSize(a.pageSize)
    }
  }

  return (
    <SearchSelectWrapper>
      <SearchSelect
        defaultValue={props.options?.[0]}
        style={customStyles}
        options={props.options}
        onChange={setValue}
      />
    </SearchSelectWrapper>
  )
}
